module.exports = __webpack_public_path__ + "img/empty-avatar.2b6658c4.svg";